<template>
  <div class="dashboard">
    <div class="flex-container column">
      <div class="dashboard_left">
        <div class="project_item">{{ project_name }}</div>
        <div class="project_item project_title">Project Title:{{ project_title }}
        </div>
        <div class="project_item project_next">Project Ref No.: {{ project_ref_no }}</div>
        <div class="project_item">Developer/Owner: {{ developer }}</div>
        <div class="project_item">Architect/QP for Building Plan: {{ architect }}</div>
        <div class="project_item">Civil & Structural Engineer: {{ civil }}</div>
        <div class="project_item">Mechanical & Electrical Engineer: {{ mechanical }}</div>
        <div class="project_item">Quantity Surveyor: {{ quantity }}</div>
        <div class="project_item">Main Contractor: {{ contractor }}</div>
        <div class="project_item project_next">Commencement Date: {{ commencement }}</div>
        <div class="project_item">Expected Date of Completion: {{ expected }}</div>
        <div class="project_item project_next">Senior Project Manager/Project Manager: {{ senior }}</div>
        <div class="project_item" style="margin-top: 3%;overflow: hidden">WSH Officer: {{ wsh }}</div>
      </div>
      <div class="dashboard_right">
        <video-vue :path="path1"></video-vue>
        <video-vue :path="path2"></video-vue>
        <video-vue :path="path3"></video-vue>
        <video-vue :path="path4"></video-vue>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import videoVue from "@/components/cctv/videoVue";

export default {
  name: "db_body",
  data() {
    return {
      project_name: '',
      project_title: '',
      project_ref_no: '',
      developer: '',
      architect: '',
      civil: '',
      mechanical: '',
      quantity: '',
      contractor: '',
      commencement: '',
      expected: '',
      senior: '',
      wsh: '',
      path1: '',
      path2: '',
      path3: '',
      path4: '',
      // path4: 'http://203.125.12.206:9080/hls/t311d4.m3u8',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let project_id = this.$route.query.proj_id
      let postData = {
        cms_conid: window.localStorage.getItem('cons_id'),
        proj_id: project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjInfo", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          var result = resp.data.result[0]
          this.project_name = result.program_name
          var name = window.localStorage.getItem('token_key')
          if ("videmo" == name) {
            this.project_name = "HDB Vision Demo"
          }
          this.project_title = result.program_content
          this.project_ref_no = result.program_reference
          this.developer = result.add_con
          this.architect = result.arch_progress
          this.civil = result.cs
          this.mechanical = result.me
          this.quantity = result.quality
          this.contractor = result.main_con
          this.commencement = result.construction_start
          this.expected = result.construction_end
          this.senior = result.pm
          this.wsh = result.wsh
        }
      })
    },
  },
  components: {
    videoVue
  }
}

</script>

<style lang="stylus" scoped>
/**
  box-sizing: border-box;
  overflow: hidden
*/
.dashboard
  width 100%
  height 100%
  font-size 1em

.flex-container.column
  position relative
  height: 100%
  width: 100%;
  margin: 0 auto;
  display flex

.dashboard_left
  width 44%
  margin-left 2%
  height 95%
  display flex
  flex-wrap: wrap;
  overflow scroll
  color white
  font-size 1.2rem
  text-align left

.project_item
  width 95%
  height 2rem
  /*overflow: hidden;*/
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

.project_title {
  width 90%
  height 8.5rem
  /*margin-left 2.5%*/
  -webkit-line-clamp: 5;
}

.project_next
  margin-top 5%

.dashboard_right
  width 54%
  height 100%
  display flex
  flex-wrap wrap

</style>



// WEBPACK FOOTER //
// src/components/body.vue